import React from 'react'
import { Button as AntButton } from 'antd'
import { ButtonProps } from 'antd/lib/button/button'
import cl from 'classnames'

import styles from './styles.module.scss'

const sizeMap = {
	large: styles.largeBtn,
	small: styles.smallBtn,
	xSmall: styles.xSmallBtn,
	middle: ''
}

type ButtonBaseProps = Omit<ButtonProps, 'size'> & {
	size?: ButtonProps['size'] | 'xSmall'
}

const ButtonBase: React.FC<ButtonBaseProps> = ({ className, size, ...props }) => {
	const sizeClassName = sizeMap[size || 'large']

	return <AntButton className={cl(styles.basicBtn, className, sizeClassName)} {...props} />
}

export default ButtonBase
